import * as React from "react";
import { Button, DropdownMenu } from "react-ui";

import { Icon } from "../../Icons/Icon";
import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { TestPageObjectHandle } from "../../Services/TestPageObjects/TestPageObjectHandle";
import { emptyRef } from "../../TypingUtils";

import { handleDropdownOpen } from "./handleDropdownOpen";

export interface DropdownButtonProps {
    size?: "small" | "medium" | "large";
    icon?: string;
    width?: string | number;
    disabled?: boolean;
    caption: string;
    children: React.ReactNode;
    "data-tid"?: string;
}

export function DropdownButton(props: DropdownButtonProps): JSX.Element {
    // disableAnimations выставлен тут ибо при анимациях react-ui генерирует предупреждения в консоли
    const theme = useCandyTheme();
    const buttonRef = React.useRef<Button>(emptyRef);

    const pageObjectId = React.useMemo(
        () => (props["data-tid"] ? `DropdownButton/${props["data-tid"]}` : `DropdownButton/${props.caption}`),
        [props["data-tid"], props.caption]
    );

    const testPageObject = React.useMemo(
        () => ({
            getType: () => "DropdownButton",
            getValue: () => props.caption,
            getSize: () => props.size,
            open: () => handleDropdownOpen(buttonRef),
        }),
        [props, buttonRef.current]
    );

    return (
        <TestPageObjectHandle id={pageObjectId} pageObject={testPageObject}>
            <DropdownMenu
                disableAnimations
                caption={({ toggleMenu }) => (
                    <Button
                        size={props.size}
                        width={props.width}
                        icon={props.icon ? <Icon name={props.icon} /> : undefined}
                        ref={buttonRef}
                        disabled={props.disabled}
                        data-tid={props["data-tid"]}
                        onClick={!props.disabled ? toggleMenu : undefined}>
                        {props.caption} <Icon name={"ArrowCDownIcon"} color={theme.dropdown.arrowIconColor} />
                    </Button>
                )}>
                {props.children}
            </DropdownMenu>
        </TestPageObjectHandle>
    );
}
